import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=a3ead32c&scoped=true&"
import script from "./institution.vue?vue&type=script&lang=js&"
export * from "./institution.vue?vue&type=script&lang=js&"
import style0 from "./institution.vue?vue&type=style&index=0&id=a3ead32c&prod&scoped=true&lang=less&"
import style1 from "./institution.vue?vue&type=style&index=1&id=a3ead32c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ead32c",
  null
  
)

export default component.exports